import { useState } from 'react';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import StatusBreakout from '../charts/status-breakout/StatusBreakout';
import { pageLinkFn } from '../links/Links';
import Problems from './Problems';
import { Row, Label, Content } from '../fixed-label-container/FixedLabelContainer';

const useStyles = makeStyles({
    smaller: {
        fontSize: 'smaller',
    },
    position: {
        position: 'relative',
    },
});

function impacted(item) {
    if (!item) return '';
    return `(${item.affected} / ${item.total} Impacted)`;
}

export default function StatusBreakoutRow({
    filters,
    excludedFilters,
    noSelection,
    disableSelection,
    entityType,
    entityUuid,
    page,
    title,
    metric,
    data,
    last,
    onTimeRangeChange,
    hideProblems,
}) {
    const classes = useStyles();
    const [positions, setPositions] = useState({});
    const isLast = metric === last;
    const counts = data?.[metric];
    const disableTimeAxis = !isLast;
    const height = isLast ? 70 : 50;
    const [timeRange, setTimeRange] = useState(undefined);

    function handleTimeRangeChange(newTimeRange) {
        setTimeRange(newTimeRange);
        onTimeRangeChange(newTimeRange);
    }

    if (!counts?.total) return null;
    return (
        <Row>
            <Label>
                {pageLinkFn(page, title, filters, excludedFilters)}{' '}
                <span className={classes.smaller}>{impacted(counts)}</span>
            </Label>
            <Content>
                <StatusBreakout
                    noSelection={noSelection}
                    disableSelection={disableSelection}
                    height={height}
                    disableTimeAxis={disableTimeAxis}
                    metricName={metric}
                    data={data}
                    onTimeRangeChange={handleTimeRangeChange}
                    onSetPositions={setPositions}
                />
                {isLast && timeRange && !hideProblems && (
                    <Problems
                        entityType={entityType}
                        entityUuid={entityUuid}
                        positions={positions}
                        timeRange={timeRange}
                    />
                )}
            </Content>
        </Row>
    );
}

StatusBreakoutRow.defaultProps = {
    filters: [],
    onTimeRangeChange: _.noop,
};
